import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { Form, Input, InputNumber, Select } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../common/components/simpleInput";
import {
  useQueryContainerCategorySelect,
  useQueryContainerUnitsSelect,
} from "./core/_hooks";
import { ContainerTypeService } from "./core/_request";
import { HttpStatusCode } from "axios";

type ContainerTypeFormTypes = {
  onFinish: () => void;
  initialValue?: any;
};

export const ContainerTypeForm = ({ onFinish, initialValue }: ContainerTypeFormTypes) => {
  const [form] = Form.useForm();

  const { data: categoryOptions, isLoading: isLoadingCategory } =
    useQueryContainerCategorySelect({}, true);
  const { data: dimensionOptions, isLoading: isLoadingDimension } =
    useQueryContainerUnitsSelect({}, true);

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,
        containerUnit: initialValue?.containerUnit
          ? {
              label: initialValue?.containerUnit?.name,
              value: initialValue?.containerUnit?.["@id"],
            }
          : null,
        containerCategory: initialValue?.containerCategory
          ? {
              label: initialValue?.containerCategory?.name,
              value: initialValue?.containerCategory?.["@id"],
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        containerUnit: values?.containerUnit?.value ?? null,
        containerCategory: values?.containerCategory?.value ?? null,
      };

      if (!dataToPost?.id) {
        const res = await ContainerTypeService.createContainerType(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await ContainerTypeService.updateContainerType(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Dimension"
                name={"containerUnit"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={dimensionOptions}
                    loading={isLoadingDimension}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
            <SimpleInput
                Form={Form}
                label="Catégorie"
                name={"containerCategory"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={categoryOptions}
                    loading={isLoadingCategory}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
